import {
  AuthModalNavigationConfig,
  AuthNavigationConfig,
  AuthURLNavigationConfig,
} from 'ui/types';

export function isModalNavigation(
  navigator: AuthNavigationConfig,
): navigator is AuthModalNavigationConfig {
  return (navigator as AuthURLNavigationConfig).routes === undefined;
}
